import React, { useState, useEffect } from "react";
import { ref, set, get } from "firebase/database";
import { rtdb } from "../firebase"; // 👈 importa tu RTDB desde firebase.js

export function AdminPanel({ claseId = "clase-123" }) {
  const [estado, setEstadoLocal] = useState("abierta");

  // Cargar estado actual de la clase al entrar
  useEffect(() => {
    const estadoRef = ref(rtdb, `clases/${claseId}/estado`);
    get(estadoRef).then((snapshot) => {
      if (snapshot.exists()) {
        setEstadoLocal(snapshot.val());
      }
    });
  }, [claseId]);

  // Cambiar estado en Firebase
  const cambiarEstado = (nuevoEstado) => {
    const estadoRef = ref(rtdb, `clases/${claseId}/estado`);
    set(estadoRef, nuevoEstado)
      .then(() => {
        setEstadoLocal(nuevoEstado);
        console.log(`✅ Clase puesta en estado: ${nuevoEstado}`);
      })
      .catch((err) => console.error("❌ Error cambiando estado:", err));
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      <h1 className="text-2xl font-bold mb-4">Panel de Admin</h1>

      <p className="mb-4">
        Estado actual de la clase:{" "}
        <span
          className={`font-bold ${
            estado === "abierta" ? "text-green-600" : "text-red-600"
          }`}
        >
          {estado.toUpperCase()}
        </span>
      </p>

      <div className="flex gap-4">
        <button
          onClick={() => cambiarEstado("abierta")}
          className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg shadow"
        >
          Abrir Clase
        </button>
        <button
          onClick={() => cambiarEstado("cerrada")}
          className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-lg shadow"
        >
          Cerrar Clase
        </button>
      </div>
    </div>
  );
}
